import "../Custom.css"
import ServicesPage from "./ServicesPage"
import {
  DIGITAL_SERVICE_PAGE_IMAGE_FOUR,
  DIGITAL_SERVICE_PAGE_IMAGE_ONE,
  DIGITAL_SERVICE_PAGE_IMAGE_THREE,
  DIGITAL_SERVICE_PAGE_IMAGE_TWO,
} from "../utils/constants"

const DigitalSolutions = () => {
  const leftColumnData = [
    {
      title: "Web Development",
      desc: "We built responsive and user-friendly websites and web applications that are both attractive and professional for your worldwide presence.",
      imgPath: DIGITAL_SERVICE_PAGE_IMAGE_ONE,
    },
    {
      title: "App Development",
      desc: "We offer portable and optimised IT solutions that will enable your business to go online using Android and iOS technologies.",
      imgPath: DIGITAL_SERVICE_PAGE_IMAGE_TWO,
    },
  ]

  const rightColumnData = [
    {
      title: "Digital Marketing",
      desc: "For any kind of digital transformation understanding the business and your product to influence your end user With Social Media Marketing, SEO, Google Analytics, Adwords & Affiliate Marketing.",
      imgPath: DIGITAL_SERVICE_PAGE_IMAGE_THREE,
    },
    {
      title: "Graphic Designing",
      desc: "This is the best tool used to attract your target audience. We create visual treats important for your online business.",
      imgPath: DIGITAL_SERVICE_PAGE_IMAGE_FOUR,
    },
  ]

  return (
    <>
      <ServicesPage prop={{ leftColumnData, rightColumnData }} />
    </>
  )
}

export default DigitalSolutions
